import { type FC, memo } from 'react';

import { SearchResults } from '@vakantiesnl/components/src/organisms/SearchResults';
import { getSearchServerSideProps } from '@vakantiesnl/components/src/pages/search/getSearchServerSideProps';
import { withGlobalStateGSSP } from '@vakantiesnl/components/src/utils/globalState/withGlobalState';
import { type FilterState, FilterStoreProvider } from '@vakantiesnl/services/src/stores/filtersStore';

import { type GlobalPageProps, type VaknlNextPage } from './_app';
import DefaultLayout from '../layout';

type Props = GlobalPageProps & {
	filters: FilterState;
};

const RenderLayout: FC<Props> = ({ filters }) => {
	return (
		<FilterStoreProvider filters={filters}>
			<SearchResults />
		</FilterStoreProvider>
	);
};

const MemoRenderLayout = memo(RenderLayout);

const SearchPage: VaknlNextPage<Props> = (props) => {
	return <MemoRenderLayout {...props} />;
};

export const getServerSideProps = withGlobalStateGSSP(getSearchServerSideProps);

SearchPage.Layout = DefaultLayout;

export default SearchPage;
